const routes = [
  {
    path: 'admin/dashboard',
    name: 'AdminDashboard',
    meta: { middleware: 'AuthAdmin' },
    component: () =>
    import("@/views/admin/dashboard/Index"),
  },
  {
    path: 'admin/analytics',
    name: 'AdminAnalytics',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/analytics/index"),
  },
  {
    path: 'admin/residents',
    name: 'AdminResidents',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/residents/resident"),
  },
  {
    path: 'admin/large-resident-companies',
    name: 'AdminLargeResidentCompanies',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/largeReidentCompanies/byName.vue"),
  },
  {
    path: 'admin/collections',
    name: 'AdminCollections',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/residents/collections"),
  },
  
  {
    path: 'admin/employees/table',
    name: 'AdminEmployees',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/employies/employees.vue"),
  },
  {
    path: 'admin/employees/collections-table',
    name: 'AdminEmployeesCollections',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/employies/collections.vue"),
  },

  // exporters
  {
    path: 'admin/exporters/employees-table',
    name: 'AdminExportersEmployees',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/exporters/employees.vue"),
  },
  {
    path: 'admin/exporters/collections-table',
    name: 'AdminExportersCollections',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/exporters/collections.vue"),
  },
  // end exporters
  
  {
    path: 'admin/general',
    name: 'AdminGeneral',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/Reports/general.vue"),
  },
  {
    path: 'admin/resedents',
    name: 'AdminResedents',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/Reports/residents.vue"),
  },
  {
    path: 'admin/quarterlyReport',
    name: 'AdminQuarterlyReport',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/quarterlyReport/byCount.vue")
  },
  {
    path: 'admin/quarterlyReportbycount',
    name: 'AdminQuarterlyReportBycount',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/quarterlyReport/bySum.vue")
  },
  
  {
    path: 'admin/auditReport',
    name: 'AdminAuditReport',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/auditReport/index.vue")
  },
  {
    path: 'admin/employees',
    name: 'AdminEmploees',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/Reports/employees.vue"),
  },
  {
    path: 'admin/exporters',
    name: 'AdminExporters',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/Reports/exporters.vue"),
  },
  {
    path: 'admin/incomes',
    name: 'AdminIncomes',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/Reports/incomes.vue"),
  },
  {
    path: 'admin/extendedInformation',
    name: 'AdminExtendedInformation',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/InTableView/NewExtendedInformation.vue"),
  },
  {
    path: 'admin/extendedInformation-by-country',
    name: 'AdminExtendedInformationByCountry',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
        import("@/views/admin/InTableView/ExtendedInformationByCountry.vue"),
  },
    {
        path: 'admin/new-extendedInformation',
        name: 'AdminNewExtendedInformation',
        meta: { middleware: 'AuthAdmin', nav: 'pulse' },
        component: () =>
            import("@/views/admin/InTableView/ExtendedInformation.vue"),
    },
  {
    path: 'admin/separation',
    name: 'AdminSeparation',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/separations/index.vue"),
  },
  {
    path: 'admin/separation/:id',
    name: 'AdminSeparationShow',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/separations/show.vue"),
  },
  {
    path: 'admin/virtualOffice',
    name: 'AdminVirtualOffice',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/virtualOffice.vue"),
  },
  {
    path: 'admin/tashkentRegions',
    name: 'AdminTashkentRegions',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/dashboard/tableOfTashkentRegion.vue"),
  },
  {
    path: 'admin/ai',
    name: 'ai',
    meta: { middleware: 'AuthAdmin', nav: 'pulse' },
    component: () =>
    import("@/views/admin/AI/index.vue"),
  },


  // {
  //   path: 'admin/news',
  //   name: 'AdminNews',
  //   meta: { middleware: 'AuthAdmin', nav: 'pulse' },
  //   component: () =>
  //   import("@/views/admin/news/Index"),
  // },{
  //   path: 'admin/news/create',
  //   name: 'AdminNewsCreate',
  //   meta: { middleware: 'AuthAdmin', nav: 'pulse' },
  //   component: () =>
  //   import("@/views/admin/news/Form"),
  // },{
  //   path: 'admin/news/edit/:id',
  //   name: 'AdminNewsEdit',
  //   meta: { middleware: 'AuthAdmin', nav: 'pulse' },
  //   component: () =>
  //   import("@/views/admin/news/Form"),
  // },{
  //   path: 'admin/news/show/:id',
  //   name: 'AdminNewsShow',
  //   meta: { middleware: 'AuthAdmin', nav: 'pulse' },
  //   component: () =>
  //   import("@/views/admin/news/Show"),
  // }
]

export default routes;
